<template>
    <div v-if="data.transfer_history !== null">
      <section v-if="data.transfer_history.length">
        <h3 class="pb-1">Case Transfer Details</h3>
        <b-row>
          <b-col class="col-12">
            <app-collapse :type="'border'">
              <app-collapse-item title="View Transfer Details" class="text-info">
                <b-table
                  stacked
                  responsive="sm"
                  :items="data.transfer_history"
                /> </app-collapse-item
            ></app-collapse>
          </b-col>
        </b-row>
      </section>
    </div>
  </template>
  
  <script>
  import { BCard, BRow, BCol, BTable } from 'bootstrap-vue'
  import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
  import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
  
  export default {
    components: {
      BCard,
      BRow,
      BCol,
      BTable,
      AppCollapse,
      AppCollapseItem
    },
    props: {
      matter: {
        default: null
      }
    },
    data() {
      return {
        data: this.matter
      }
    }
  }
  </script>
  